<li class="navbar--item flex flex-col mx-2 cursor-pointer relative transition-colors">
  <a *ngIf="!hasChilds" [routerLink]="route" [routerLinkActive]="'navbar--item-active'" class="transition-all">
    {{ title }}
  </a>
  <ng-container *ngIf="hasChilds">
    <input id="{{name}}" class="sub-menu-trigger" name="{{name}}" hidden />
    <label class="w-full transition-all" for="{{name}}">
      {{ title }}
    </label>
  </ng-container>
  <ul *ngIf="hasChilds" class="navmenu--sub-menu">
    <ng-content>
    </ng-content>
  </ul>
</li>